var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 512,
    height: 341.337,
    y: 85.333
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496e2d"
    },
    points: "301.255 255.996 512 115.499 512 85.33 466.745 85.33 256 225.826 45.255 85.33 0 85.33 0 115.499 210.745 255.996 0 396.493 0 426.662 45.255 426.662 256 286.166 466.745 426.662 512 426.662 512 396.493"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f0f0f0"
    },
    points: "278.261 233.735 278.261 202.254 278.261 85.33 233.739 85.33 233.739 202.254 233.74 233.735 233.74 233.735 202.258 233.735 0 233.735 0 278.257 202.258 278.257 233.739 278.257 233.739 309.738 233.739 426.662 278.261 426.662 278.261 309.739 278.261 278.258 278.261 278.257 309.743 278.257 512 278.257 512 233.735 309.742 233.735 278.262 233.735"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBas);
export default __webpack_public_path__ + "static/media/bas.285722ae45b6ef1ca7cc80a274256596.svg";
export { ForwardRef as ReactComponent };